class @App.Components.TededLessonsGrid
  constructor: ->
    @$body = $('body')
    @$lessonsGrid = $('#lessons-grid')
    @filters = filters = ['subtitles', 'content_type', 'student_level', 'duration']
    @activeClass = 'tdd-dropdown--active'
    @spinner = $('<img />').attr('src', @$lessonsGrid.data('spinner'))
    @updateCategoryLabel()
    @bindElements()

  bindElements: ->
    History.Adapter.bind window, 'statechange', (e) ->
      window.location.reload()

    @$body.on 'click.lessonsgrid', '[data-category]', (e) =>
      e.preventDefault()
      $selected = $(e.currentTarget)
      $parentMenu = $selected.closest('[data-dropdown="menu"]')
      $('[data-category]').attr('aria-selected', 'false')
      $selected.attr('aria-selected', 'true')
      @updateActiveClasses $parentMenu, '[aria-selected="true"]'
      @updateCategoryLabel()
      @updateFilters true

    @$body.on 'click.lessonsgrid', '[data-lesson-filter]', (e) =>
      e.preventDefault()
      @updateFilters true

    @$body.on 'click.lessonsgrid', '[data-sort-by], [data-category], [data-lesson-value], [data-filter-clear]', (e) =>
      $('#lessons-filters [data-dropdown="menu"]')
        .toArray()
        .forEach (menu) =>
          @dispatchEvent 'tededdropdown.close',
            'menuId': '#' + $(menu).attr 'id'

    @$body.on 'click.lessonsgrid', '#lessons-filters [data-dropdown-anchor]', (e) =>
      $('#lessons-filters [data-dropdown-anchor]')
        .not($(e.currentTarget))
        .find '[data-dropdown="menu"]'
        .toArray()
        .forEach (menu) =>
          @dispatchEvent 'tededdropdown.close',
            'menuId': '#' + $(menu).attr 'id'

  buildFilterString: (filtername) ->
    $("[data-lesson-filter='#{filtername}'][aria-checked='true']")
      .map () -> $(this).data('lesson-value')
      .get()
      .join('+')

  getFilters: () =>
    @filters.reduce(((result, filterName) =>
      filterString = @buildFilterString(filterName)
      if !!filterString then result[filterName] = filterString
      result
    ), {})

  updateCategoryLabel: =>
    $category = $('[data-category][aria-selected="true"]').first().text()
    defaultText = $('[data-category-label]').data('category-label')
    $('[data-category-label]').text $category || defaultText

  updateFilters: =>
    params = @getFilters()
    catTitle = ""
    $category = $('[data-category][aria-selected="true"]').first()
    $sort = $('[data-filter-opt="sortby"][aria-checked="true"]').first()

    if $category.length > 0
      catTitle = $category.text()
      params['category'] = $category.data('category')

    if $sort.length > 0
      params['direction'] = $sort.data('sort-direction')
      params['sort'] = $sort.data('sort-by')

    lessons_url = "/lessons?#{decodeURIComponent($.param( params ))}"
    @reloadContent(lessons_url, catTitle)

  reloadContent: (lessons_url, pageTitle) =>
    $click_blocker = $('<div />').addClass('clickBlockingOverlay')
    $loading_message = $('<div />').text(' Loading lessons...').prepend(@spinner).append('<br/><br/>')

    @$body.append $click_blocker
    @$lessonsGrid.before $loading_message
    $('[data-lesson-grid-content]').hide()

    $.getScript lessons_url, ->
      $click_blocker.remove()
      $loading_message.remove()
      $('[data-lesson-grid-content]').show()

    if pageTitle?
      document.title = "#{pageTitle} Lessons | TED-Ed"

    history.pushState({ module: 'lessons' }, document.title, lessons_url)

  updateActiveClasses: ($menu, selector) ->
    activeClass = @activeClass
    $menu.find('.' + @activeClass).removeClass activeClass
    $menu.find(selector).addClass activeClass
    $menu.find('[aria-hidden]').has(selector)
      .each () ->
        id = '#' + $(this).attr('id')
        $("[aria-haspopup][href='#{id}']").addClass activeClass

  dispatchEvent: (eventName, params) ->
    closeMenu = document.createEvent 'CustomEvent'
    closeMenu.initCustomEvent eventName, false, false, params
    document.dispatchEvent(closeMenu)

$ ->
  new App.Components.TededLessonsGrid if $('#lessons-grid').length
